import css from 'styled-jsx/css';

export default css`@charset "UTF-8";
.popSlidein__wrapper .btn-cancel {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-bottom: calc(20px + constant(safe-area-inset-bottom));
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
  letter-spacing: 2px;
  font-size: 1rem;
  font-weight: normal;
  text-align: center;
  background-color: #fff;
  cursor: pointer; }
  .popSlidein__wrapper .btn-cancel::after {
    content: '關閉'; }

.popSlidein__content {
  padding: 0 10px;
  padding-top: 5px;
  border-bottom: 1px solid #e3e3e3; }
  .popSlidein__content .popSlidein__title {
    margin: 5px auto;
    text-align: center;
    color: #333;
    letter-spacing: 1px;
    font-weight: bold;
    font-size: 0.9rem; }
  .popSlidein__content .popSlidein__line {
    display: block;
    border-bottom: #e1e1e1 solid 1px;
    margin: 3px auto; }
  .popSlidein__content.popSlidein__content--info .popSlidein__timetable {
    margin: 10px auto;
    line-height: 2em; }
    .popSlidein__content.popSlidein__content--info .popSlidein__timetable .--active {
      color: #838eff; }
`